import React, { type FunctionComponent } from 'react'
import { Layout } from './Layout'
import { RecentMessageProvider } from './Context'
import type { RowProps } from '@ztechapps/webui.data-tools'
import type { ChatMessage } from '@ztechapps/common.contract'
export type RecentMessageListRowProps = RowProps & ChatMessage

export type Components = {
  ListRowActions: FunctionComponent<RecentMessageListRowProps>
}

export type RecentMessagesProps = {
  routesDef?: any
  components: any
  height: number | string
}
export const RecentMessages = (props: RecentMessagesProps) => {
  return (
    <RecentMessageProvider {...props}>
      <Layout />
    </RecentMessageProvider>
  )
}
